export const transformAllergens = (allergen: string) => ({ Title: allergen });
